// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'row-right-fill';

export const Component = () => (
  <path d='M23.563 0H.958a.946.946 0 0 0-.67.287.946.946 0 0 0-.288.67v22.606c0 .24.096.48.287.67a.946.946 0 0 0 .67.288h22.606c.24 0 .48-.096.67-.287a.946.946 0 0 0 .288-.67V.957a.946.946 0 0 0-.287-.67.946.946 0 0 0-.67-.288ZM.958 7.855V.958h14.75v6.897H.959Zm0 7.854V8.813h14.75v6.896H.959Zm14.75 7.854H.959v-6.897h14.75v6.897Z' />
);

export const viewBox = '0 0 25 25';
